<template>
  <div class="full-width-inside-base-container">
    <base-card color="accent">
      <v-layout fluid py-2>
        <v-flex text-xs-left>
          <tk-btn color="accent" @click="onClickShowFilters">
            <v-icon left dark size="20">fas fa-sliders-h</v-icon>
            <span class="text-none">{{ $t('SEARCH.FILTER')}}</span>
            <v-icon
              right
              dark
              size="20"
            >{{ showFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
          </tk-btn>
        </v-flex>
        <v-flex text-xs-right>
          <tk-btn color="accent" @click="onClickShowSort">
            <span class="text-none" v-t="'SEARCH.SORT'" />
            <v-icon
              right
              dark
              size="20"
            >{{ showSortPanel ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
          </tk-btn>
        </v-flex>
      </v-layout>
    </base-card>
    <div class="mx-3">
      <transition name="slide-y-transition">
        <MobileFiltersPanel v-show="showFilters" :filters="filters" @search="onMobileSearch" />
      </transition>
      <transition name="slide-y-transition">
        <MobileSortPanel
          @sortBy="onSortBy"
          v-show="showSortPanel"
          :filters="filters"
          :sortType="sortType"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import MobileFiltersPanel from "./FilterPanel/FiltersPanel";
import MobileSortPanel from "./SortPanel";
import { SearchFilters } from "@/services/search/SearchFilters";
import { ROUTE_QUERY, MOBILE_SEARCH_BUTTON_EVENT } from "@/AppKeys";

export default {
  props: ["sortType"],

  inject: [ROUTE_QUERY],

  components: {
    MobileFiltersPanel,
    MobileSortPanel,
  },

  data: () => ({
    showFilters: false,
    showSortPanel: false,
    filters: new SearchFilters(),
  }),

  computed: {
    routeQuery() {
      return this[ROUTE_QUERY];
    },
  },

  created() {
    console.log("created. Mobile search controls");
    this.$root.$on(MOBILE_SEARCH_BUTTON_EVENT, () => {
      console.log("MOBILE_SEARCH_BUTTON_EVENT");
      this.onClickShowFilters();
    });
  },

  beforeDestroy() {
    this.$root.$off(MOBILE_SEARCH_BUTTON_EVENT);
  },

  methods: {
    onClickShowFilters() {
      this.showFilters = !this.showFilters;
      if (this.showFilters && this.showSortPanel) {
        this.showSortPanel = false;
      }
    },

    onClickShowSort() {
      this.showSortPanel = !this.showSortPanel;
      if (this.showSortPanel && this.showFilters) {
        this.showFilters = false;
      }
    },

    onSortBy(e) {
      this.showSortPanel = false;
      this.$emit("sortBy", e);
    },

    onMobileSearch() {
      console.log("onMobileSearch", this.$route.query);
      this.showFilters = false;
      this.filters.searchText = this.$route.query.keyword;

      console.log(this.filters);

      this.routeQuery.push(this.filters.toQuery());
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent;
  color: red;
}
</style>